import { apiSlice } from './apiSlice';

export const rcpApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getProfile: builder.query({
      query: (token) => ({
        url: `${process.env.REACT_APP_AUTHORITY}me`,
        method: 'GET',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      }),
    }),
  }),
});

export const { useGetProfileQuery } = rcpApiSlice;
